import React from 'react';
import FormTextarea from 'views/EMR/components/FillableForm/components/FormTextarea';
import {
  FieldComponentProps,
} from 'views/EMR/components/FillableForm/types';
import {
  placeholderByType,
} from 'views/EMR/components/FillableForm/utils/fieldPositioning';

export default function LongText({
  field,
  value,
  onChange,
  error,
}: FieldComponentProps) {
  const placeholder = placeholderByType[field.type] ?? 'Please enter a value';
  return (
    <FormTextarea
      id={field?.id ?? ''}
      key={field?.id}
      autoFocus
      error={error}
      placeholder={placeholder}
      value={(value?.value ?? '') as string}
      onChange={(text) => {
        onChange?.({ ...value, value: text });
      }}
    />
  );
}
